(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) return 0;

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return formatString.replace(placeholderRegex, value);
  }

  function initProduct(section) {
    var sectionId = section.dataset.sectionId;
    var productJsonEl = document.getElementById('ProductJson-' + sectionId);
    if (!productJsonEl) return;

    var product = JSON.parse(productJsonEl.textContent);
    var form = section.querySelector('[data-rng-product-form]');
    var optionInputs = form ? form.querySelectorAll('[data-rng-product-option]') : [];
    var variantSelect = form ? form.querySelector('[data-rng-product-variant-select]') : null;
    var priceEl = section.querySelector('[data-rng-product-current-price]');
    var comparePriceEl = section.querySelector('[data-rng-product-compare-price]');
    var addToCartBtn = form ? form.querySelector('[data-rng-product-add-to-cart]') : null;
    var addToCartText = form ? form.querySelector('[data-rng-product-add-to-cart-text]') : null;
    var paymentButton = form ? form.querySelector('[data-rng-product-payment-button]') : null;
    var featuredImage =
      section.querySelector('[data-rng-product-featured-image]') ||
      document.getElementById('RngProductImage-' + sectionId);
    var thumbnails = section.querySelectorAll('[data-rng-product-thumbnail]');
    var prevBtn = section.querySelector('[data-rng-product-prev]');
    var nextBtn = section.querySelector('[data-rng-product-next]');
    var thumbnailsScroll = section.querySelector('[data-rng-product-thumbnails-scroll]');
    var currentMediaIndex = 0;
    var mediaSrcMap = {};
    var preloadedSrc = {};
    var moneyFormat = (window.theme && window.theme.moneyFormat) || '${{amount}}';
    var strings = (window.theme && window.theme.productStrings) || {
      addToCart: 'Add to cart',
      soldOut: 'Sold out'
    };

    function getSelectedOptions() {
      return Array.from(optionInputs).map(function (input) {
        return input.value;
      });
    }

    function findVariant() {
      var selectedOptions = getSelectedOptions();
      return product.variants.find(function (variant) {
        return variant.options.every(function (option, index) {
          return option === selectedOptions[index];
        });
      });
    }

    thumbnails.forEach(function (thumb) {
      if (thumb.dataset.mediaSrc) {
        mediaSrcMap[thumb.dataset.mediaId] = thumb.dataset.mediaSrc;
      }
    });

    function getOptimizedSrc(media) {
      if (!media) return '';

      var mappedSrc = mediaSrcMap[String(media.id)];
      if (mappedSrc) return mappedSrc;

      var src = (media.preview_image && media.preview_image.src) || media.src;
      if (!src) return '';

      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=900';
    }

    function preloadSrc(src) {
      if (!src || preloadedSrc[src]) return;

      preloadedSrc[src] = true;
      var img = new Image();
      img.decoding = 'async';
      img.src = src;
    }

    function preloadMediaIndexes(indexes) {
      indexes.forEach(function (index) {
        if (index < 0 || index >= product.media.length) return;
        preloadSrc(getOptimizedSrc(product.media[index]));
      });
    }

    function preloadAdjacent() {
      preloadMediaIndexes([currentMediaIndex - 1, currentMediaIndex + 1]);
    }

    function swapFeaturedSrc(src, alt) {
      if (!featuredImage || featuredImage.tagName !== 'IMG' || !src) return;

      if (featuredImage.currentSrc === src || featuredImage.src === src) {
        featuredImage.alt = alt;
        featuredImage.classList.remove('is-loading');
        return;
      }

      featuredImage.classList.add('is-loading');

      var loader = new Image();
      loader.decoding = 'async';
      loader.onload = function () {
        featuredImage.src = src;
        featuredImage.removeAttribute('srcset');
        featuredImage.alt = alt;
        featuredImage.classList.remove('is-loading');
      };
      loader.onerror = function () {
        featuredImage.classList.remove('is-loading');
      };
      loader.src = src;
    }
    function getMediaIndex(mediaId) {
      return product.media.findIndex(function (item) {
        return String(item.id) === String(mediaId);
      });
    }

    function updateThumbnailState(mediaId) {
      thumbnails.forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.dataset.mediaId === String(mediaId));
      });
    }

    function scrollThumbnailIntoView(mediaId) {
      var thumb = section.querySelector('[data-rng-product-thumbnail][data-media-id="' + mediaId + '"]');
      if (!thumb || !thumbnailsScroll) return;

      var scrollLeft = thumb.offsetLeft - (thumbnailsScroll.clientWidth - thumb.offsetWidth) / 2;
      thumbnailsScroll.scrollTo({
        left: Math.max(0, scrollLeft),
        behavior: 'smooth'
      });
    }

    function setFeaturedMedia(media) {
      if (!featuredImage || !media) return;

      var imageSrc = getOptimizedSrc(media);
      if (!imageSrc) return;

      swapFeaturedSrc(imageSrc, media.alt || product.title);

      var mediaIndex = getMediaIndex(media.id);
      if (mediaIndex >= 0) currentMediaIndex = mediaIndex;

      updateThumbnailState(media.id);
      scrollThumbnailIntoView(media.id);
      preloadAdjacent();
    }

    function goToMediaIndex(index) {
      if (!product.media.length) return;

      var nextIndex = index;
      if (nextIndex < 0) nextIndex = product.media.length - 1;
      if (nextIndex >= product.media.length) nextIndex = 0;

      setFeaturedMedia(product.media[nextIndex]);
    }

    function updateImage(variant) {
      if (!variant || !variant.featured_media) return;

      var media = product.media.find(function (item) {
        return String(item.id) === String(variant.featured_media.id);
      });

      if (media) {
        setFeaturedMedia(media);
        return;
      }

      if (variant.featured_image && featuredImage && featuredImage.tagName === 'IMG') {
        var variantSrc = mediaSrcMap[String(variant.featured_image.id)] || getOptimizedSrc({
          id: variant.featured_image.id,
          preview_image: variant.featured_image,
          src: variant.featured_image.src
        });

        swapFeaturedSrc(variantSrc, variant.featured_image.alt || product.title);

        var imageIndex = getMediaIndex(variant.featured_image.id);
        if (imageIndex >= 0) currentMediaIndex = imageIndex;

        updateThumbnailState(variant.featured_image.id);
        scrollThumbnailIntoView(variant.featured_image.id);
        preloadAdjacent();
      }
    }

    function updatePrice(variant) {
      if (!priceEl) return;

      priceEl.textContent = formatMoney(variant.price, moneyFormat);

      if (comparePriceEl) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePriceEl.textContent = formatMoney(variant.compare_at_price, moneyFormat);
          comparePriceEl.classList.remove('hidden');
        } else {
          comparePriceEl.classList.add('hidden');
        }
      }
    }

    function updateAvailability(variant) {
      var isAvailable = variant && variant.available;

      if (variantSelect && variant) {
        variantSelect.value = variant.id;
      }

      if (addToCartBtn) {
        addToCartBtn.disabled = false;
        addToCartBtn.removeAttribute('aria-disabled');
      }

      if (addToCartText) {
        addToCartText.textContent = isAvailable ? strings.addToCart : strings.soldOut;
      }

      if (form) {
        form.classList.toggle('rng-product__form--sold-out', !isAvailable);
      }

      if (paymentButton) {
        paymentButton.style.display = isAvailable ? '' : 'none';
      }
    }

    function onVariantChange() {
      var variant = findVariant();
      if (!variant) return;

      updatePrice(variant);
      updateAvailability(variant);
      updateImage(variant);

      if (section.dataset.enableHistoryState === 'true' && window.history.replaceState) {
        var url = window.location.pathname + '?variant=' + variant.id;
        window.history.replaceState({ path: url }, '', url);
      }
    }

    optionInputs.forEach(function (input) {
      input.addEventListener('change', onVariantChange);
    });

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var mediaId = thumb.dataset.mediaId;
        var media = product.media.find(function (item) {
          return String(item.id) === String(mediaId);
        });

        setFeaturedMedia(media);
      });

      thumb.addEventListener('mouseenter', function () {
        preloadSrc(thumb.dataset.mediaSrc);
      });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        goToMediaIndex(currentMediaIndex - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        goToMediaIndex(currentMediaIndex + 1);
      });
    }

    if (product.media.length) {
      var activeThumb = section.querySelector('[data-rng-product-thumbnail].is-active');
      var initialIndex = activeThumb ? getMediaIndex(activeThumb.dataset.mediaId) : 0;
      if (initialIndex < 0) initialIndex = 0;
      currentMediaIndex = initialIndex;
      preloadAdjacent();
    }

    if (form) {
      onVariantChange();
    }
  }

  function init() {
    document.querySelectorAll('[data-rng-product]').forEach(initProduct);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
